import React, { useState, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import Hero from "../components/Hero";
import Divider from "../components/Divider";
import OurProductLine from "../components/OurProductLine";
import StickyImage from "../components/StickyImage";
import ProductsSection from "../components/ProductsSection";
import IndustrialVersatileSurfaces from "../components/IndustrialVersatileSurfaces";
import RedSection from "../components/About/RedSection";
import ProductDivider from "../components/ProductDivider";
import ComparisonTable from "../components/ComparisonTable";
import ParallaxSection from "../components/ParallaxSection";
import { CONTENT_TYPES } from "../constants/contentTypes";
import './Home.css';
import StickySplitBackground from "../components/StickySplitBackground";
import { fetchProducts } from "../contentful";
import MadeInAmerica from "../components/MadeInAmerica";

console.log('[Industrial] Rendering Industrial');

const Industrial = () => {
  console.log('[Industrial] Rendering Industrial page');
  // InView hooks for key markers
  const { ref: productLineEndInViewRef, inView: productLineEndInView } = useInView({
    threshold: 0,
  });
  const { ref: footerSentinelRef, inView: footerSentinelInView } = useInView({
    threshold: 0.1,
  });

  // Create refs
  const productLineEndElement = useRef(null);
  const setProductLineEndRef = (node) => {
    productLineEndInViewRef(node);
    productLineEndElement.current = node;
  };

  // State for products
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch products
  useEffect(() => {
    const loadProducts = async () => {
      try {
        const fetchedProducts = await fetchProducts(CONTENT_TYPES.PROFESSIONAL);
        setProducts(fetchedProducts);
        setIsLoading(false);
      } catch (error) {
        console.error("Error loading products:", error);
        setIsLoading(false);
      }
    };

    loadProducts();
  }, []);

  // Responsive margin-top for the overlay Our Products section
  const getMarginTop = (width) => {
    if (width >= 2560) return "-100px";    // 4K displays
    else if (width >= 1536) return "-150px"; // Large desktops
    else if (width >= 1280) return "-190px"; // Standard desktops
    else if (width >= 1024) return "-250px"; // Smaller desktops / large tablets
    else if (width >= 768) return "-300px";   // Tablets
    else return "-350px";                     // Mobile devices
  };

  const [sectionMarginTop, setSectionMarginTop] = useState(getMarginTop(window.innerWidth));
  useEffect(() => {
    const handleResize = () => {
      setSectionMarginTop(getMarginTop(window.innerWidth));
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const heroImageSrc = "/images/B2BRRBottlesHeroImage2.png";
  console.log('[Industrial] Passing heroImageSrc to OurProductLine:', heroImageSrc);

  console.log('[Industrial] Rendering with content type:', CONTENT_TYPES.PROFESSIONAL);

  return (
    <>
      <div className="relative w-full max-w-[100vw] overflow-x-hidden">
        <Hero />

        {/* Product Line Section */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            boxShadow: "0px 20px 30px rgba(0,0,0,0.3)",
            padding: "0rem 0rem",
            marginTop: "0rem",
            marginBottom: "4rem"
          }}
        >
          {console.log('[Industrial] Rendering OurProductLine with heroImageSrc:', heroImageSrc)}
          <OurProductLine heroImageSrc={heroImageSrc} />
          <MadeInAmerica />
        </div>
        
        <div ref={setProductLineEndRef} />

        <StickySplitBackground
          leftImage="https://images.ctfassets.net/hdznx4p7ef81/6MXcrCMvzECnPbiShD3btY/80112993ad2b429ca9c4576dbb672f4e/APC_Industrial_Strength_for_Tough_Jobs__1_.png"
          rightImage="https://images.ctfassets.net/hdznx4p7ef81/4qZzk5uIy0wOYMAQFsuUKc/261d1fbaa8c110973c50185e1f2a909e/RR_Cleaning_Mess_Zoomed_Out.jpg"
          className="my-4 md:my-16"
          showOverlay={productLineEndInView}
        >
          <div className="container mx-auto px-4 py-4 md:py-16">
            <h2 className="text-xl md:text-3xl font-bold text-center mb-2 md:mb-8">
              For the toughest cleaning jobs Rugged Red B2B Industrial Strength Cleaners
            </h2>
            <p className="text-sm md:text-lg text-center max-w-2xl mx-auto">
              For the toughest cleaning jobs Rugged Red B2B Industrial Strength Cleaners
            </p>
          </div>
        </StickySplitBackground>
        
        <div ref={setProductLineEndRef} />

        {/* Products Section with Sticky Background */}
        <ProductsSection 
          contentType={CONTENT_TYPES.PROFESSIONAL}
          title="Our Products"
          isProfessional={true}
          showQuoteButton={true}
        />

        <IndustrialVersatileSurfaces />
        <RedSection />
      </div>

      {/* Footer Sentinel */}
      <div ref={footerSentinelRef} style={{ height: "1px" }}></div>
    </>
  );
};

export default Industrial; 